import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer: React.FC = () => {
  return (
    <div className="footer-block">
      <footer className="footer" role="contentinfo">
        <p className="copy">© 2026 REQUESTA. All rights reserved.</p>
        <nav className="footer-nav" aria-label="Footer">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms & Conditions</Link>
        </nav>
      </footer>
    </div>
  );
};

export default Footer;
